import { computed, nextTick, ref } from "vue";

type OptionValue = string | number;

const KEY_DELTAS: Record<string, number> = {
  ArrowRight: 1,
  ArrowDown: 1,
  ArrowLeft: -1,
  ArrowUp: -1,
};

export const useRovingSelection = (
  getOptions: () => { value: OptionValue }[],
  getModelValue: () => OptionValue | null,
  select: (value: OptionValue) => void,
  isDisabled: () => boolean,
) => {
  const rootRef = ref<HTMLElement | null>(null);

  const tabbableIndex = computed(() => {
    const selectedIndex = getOptions().findIndex((option) => option.value === getModelValue());

    return selectedIndex === -1 ? 0 : selectedIndex;
  });

  const isTabbable = (index: number): boolean => index === tabbableIndex.value;

  const onKeydown = async (event: KeyboardEvent, index: number): Promise<void> => {
    const options = getOptions();
    let targetIndex: number | null = null;

    if (event.key in KEY_DELTAS) {
      targetIndex = (index + KEY_DELTAS[event.key] + options.length) % options.length;
    } else if (event.key === "Home") {
      targetIndex = 0;
    } else if (event.key === "End") {
      targetIndex = options.length - 1;
    }

    if (targetIndex === null || isDisabled()) {
      return;
    }

    event.preventDefault();
    select(options[targetIndex].value);

    await nextTick();

    rootRef.value?.querySelectorAll<HTMLElement>("[data-roving-item]")[targetIndex]?.focus();
  };

  return { rootRef, isTabbable, onKeydown };
};
